export class AppSettings {
    public static version: string = '1.5.0';
}
